import AccessDeniedIcon from '@assets/media/access-denied-icon.svg';
import { translationPacket } from 'common/actions';
import { FullscreenError } from 'common/components/full-screen-error';
import { H1 } from 'common/components/Typography';
import { deleteUserObject } from 'common/services/helpers';
import { getScalablePixel } from 'common/utils';
import { useSignOut } from 'common/utils/hooks';
import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

export const Title = styled(H1)`
  font-size: ${getScalablePixel(48)}px;
`;

interface AccessDeniedProps {
  i18n: typeof translationPacket;
}
function AccessDenied({ i18n }: AccessDeniedProps) {
  const signOut = useSignOut();

  const onPrimaryButtonPress = React.useCallback(async () => {
    deleteUserObject();
    await signOut();
    window.location.reload();
  }, []);

  if (isEmpty(i18n)) {
    return null;
  }

  return (
    <FullscreenError
      title={<Title>{i18n.authentication.accessDenied}</Title>}
      description={i18n.authentication.accessDeniedDescription}
      info={''}
      icon={AccessDeniedIcon}
      onPrimaryButtonPress={onPrimaryButtonPress}
    />
  );
}

const mapStateToProps = ({ i18n }: any) => ({
  i18n
});

export default React.memo(connect(mapStateToProps, {})(AccessDenied));
